<div class="confirm-box mb-3">
  <mat-radio-group [(ngModel)]="selectedSubscriptionIndex" aria-label="Select an option">
    @for (plan of sellingPlans(); track plan; let i = $index) {
      <div class="radio p-3" (click)="selectSubscription(i)">
        <mat-radio-button [value]="i" class="w-100">
          <div class="d-flex justify-content-between align-items-center w-100">
            <span>Subscribe & Save</span>
            <span class="price price-title">${{planPrices()[i]?.toFixed(2)}}</span>
          </div>
        </mat-radio-button>
        <div class="align-with-radio">
          {{plan?.name}}
          <ul class="shift-left">
            <li>
              Automatically delivered on your schedule
            </li>
            <li>
              No obligation, modify or cancel your subscription at anytime
            </ul>
          </div>
        </div>
        <div class="d-flex align-items-center justify-content-center">
          <fieldset>
          </fieldset>
        </div>
      }
      <div class="radio p-3" (click)="selectSubscription(sellingPlans().length)">
        <mat-radio-button class="radio" [value]="sellingPlans().length">
          <div class="d-flex justify-content-between align-items-center w-100">
            <span>One time purchase</span>
            <span class="price price-title">${{originalPrice().toFixed(2)}}</span>
          </div>
        </mat-radio-button>
      </div>
    </mat-radio-group>
  </div>
